var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Select,{attrs:{"size":"large","options":_setup.options,"placeholder":"请选择专业","allowClear":"","loading":_setup.loading},on:{"change":_setup.onChange},model:{value:(_setup.majorValue),callback:function ($$v) {_setup.majorValue=$$v},expression:"majorValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }